import { GripVertical, Plus } from 'lucide-react'

const columns = [
  {
    id: 'new',
    title: 'Novos',
    cards: [
      { name: 'Carlos Lima', cause: 'Imobiliário', urgency: 'Alta', time: '2h atrás' },
      { name: 'Pedro Souza', cause: 'Cível', urgency: 'Baixa', time: '4h atrás' },
    ],
  },
  {
    id: 'conversation',
    title: 'Em Conversa',
    cards: [
      { name: 'João Santos', cause: 'Família', urgency: 'Média', time: '25 min atrás' },
    ],
  },
  {
    id: 'qualified',
    title: 'Qualificados',
    cards: [
      { name: 'Maria Silva', cause: 'Trabalhista', urgency: 'Alta', time: '10 min atrás' },
      { name: 'Fernanda Costa', cause: 'Trabalhista', urgency: 'Média', time: '1d atrás' },
    ],
  },
  {
    id: 'scheduled',
    title: 'Agendados',
    cards: [
      { name: 'Ana Oliveira', cause: 'Contrato', urgency: 'Baixa', time: '1h atrás' },
    ],
  },
]

export default function KanbanPage() {
  return (
    <div className="space-y-6">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h1 className="font-serif text-2xl font-semibold text-foreground">Kanban</h1>
          <p className="mt-1 text-sm text-muted-foreground">Pipeline de leads por estágio</p>
        </div>
        <button className="flex h-10 items-center justify-center gap-2 rounded-md bg-primary px-4 text-sm font-medium text-primary-foreground hover:bg-primary/90 transition-colors touch-target">
          <Plus className="h-4 w-4" />
          Novo Lead
        </button>
      </div>

      {/* Mobile: Stacked Columns */}
      <div className="space-y-6 lg:hidden">
        {columns.map((column) => (
          <div key={column.id} className="rounded-lg border border-border bg-card">
            <div className="flex items-center justify-between border-b border-border px-4 py-3">
              <h2 className="text-sm font-semibold text-foreground">{column.title}</h2>
              <span className="inline-flex h-6 w-6 items-center justify-center rounded-full bg-muted text-xs font-medium text-muted-foreground">
                {column.cards.length}
              </span>
            </div>
            <div className="space-y-2 p-3">
              {column.cards.map((card) => (
                <div key={card.name} className="rounded-md border border-border bg-background p-3 space-y-2">
                  <div className="flex items-start justify-between">
                    <p className="text-sm font-medium text-foreground">{card.name}</p>
                    <GripVertical className="h-4 w-4 text-muted-foreground/50" />
                  </div>
                  <p className="text-xs text-muted-foreground">{card.cause}</p>
                  <div className="flex items-center justify-between text-xs text-muted-foreground">
                    <span>Urgência: {card.urgency}</span>
                    <span>{card.time}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* Desktop: Horizontal Board */}
      <div className="hidden lg:grid lg:grid-cols-4 lg:gap-4">
        {columns.map((column) => (
          <div key={column.id} className="rounded-lg border border-border bg-muted/30">
            <div className="flex items-center justify-between border-b border-border px-4 py-3">
              <h2 className="text-sm font-semibold text-foreground">{column.title}</h2>
              <span className="inline-flex h-6 w-6 items-center justify-center rounded-full bg-muted text-xs font-medium text-muted-foreground">
                {column.cards.length}
              </span>
            </div>
            <div className="space-y-2 p-3">
              {column.cards.map((card) => (
                <div key={card.name} className="cursor-grab rounded-md border border-border bg-card p-3 shadow-sm hover:shadow-md transition-shadow space-y-2">
                  <div className="flex items-start justify-between">
                    <p className="text-sm font-medium text-foreground">{card.name}</p>
                    <GripVertical className="h-4 w-4 text-muted-foreground/50" />
                  </div>
                  <p className="text-xs text-muted-foreground">{card.cause}</p>
                  <div className="flex items-center justify-between text-xs text-muted-foreground">
                    <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-medium ${
                      card.urgency === 'Alta' ? 'bg-destructive/10 text-destructive' :
                      card.urgency === 'Média' ? 'bg-accent/10 text-accent' :
                      'bg-muted text-muted-foreground'
                    }`}>
                      {card.urgency}
                    </span>
                    <span>{card.time}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}